{
    "releaseNotes": {
        "tabName": "Release History",
        "accordianHeading": "Release me@eon V<version>",
        "accordianMyHelpHeading": "Release MyHelp (me@eon) V<version>",
        "accordianMyHelpNewHeading": "Release MyHelp V<version>",
        "whatsNew": "What's New",
        "tipsAndTricks": "Tips and Tricks",
        "faq": "FAQ"
    },
    "featureRoadmap": {
        "tabName": "Features & Roadmap"
    },
    "ourTeam": {
        "tabName": "Our Team",
        "keyMembers": "Key Members"
    }
}